<template>
  <div class="sub-page-header">
    <button class="back-btn" type="button" @click="goBack">&lt;</button>
    <div class="title">{{ title }}</div>
    <div class="placeholder"></div>
  </div>
</template>

<script>
export default {
  name: 'SubPageHeader',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  methods: {
    goBack() {
      this.$router.back();
    }
  }
};
</script>

<style scoped lang="scss">
.sub-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 15.38462vw;
  padding: 0 3.58974vw;
  background: #fff;
  border-bottom: 1vw solid #f7f7f7;
  position: sticky;
  top: 0;
  z-index: 100;
}

.back-btn {
  width: 7.17949vw;
  height: 7.17949vw;
  border: none;
  border-radius: 1.53846vw;
  background: #e5e5e5;
  color: #ffffff;
  font-size: 4.10256vw;
  line-height: 7.17949vw;
  text-align: center;
  padding: 0;
}

.title {
  font-size: 6vw;
  font-weight: 700;
  color: #000;
  line-height: 1;
}

.placeholder {
  width: 7.17949vw;
}
</style>
